export const imageExtensions = ['.jpg', '.jpeg', '.gif', '.png'];

export function validateFile(name, extensions) {
  const index = name.lastIndexOf('.');
  if (index === -1) {
    // The file has no extension, so is not valid
    alert(
      'File "' + name + '" could not be uploaded because has no extension.'
    );
    return false;
  } else if (extensions.length > 0) {
    const fileExtension = name.substring(index);
    if (
      extensions.find(
        (element) => element.toLowerCase() === fileExtension.toLowerCase()
      ) === undefined
    ) {
      alert(
        'File "' +
          name +
          '" has an invalid extensions, should be one of [' +
          extensions.join(', ') +
          '].'
      );
      return false;
    }
  }

  return true;
}



// WEBPACK FOOTER //
// ./src/services/utils/files-util.js